import { NgModule } from '@angular/core';
import { Ga4GgCheckoutReviewPageEventBuilder } from './ga4-gg-checkout-review-page-event.builder';

@NgModule({})
export class Ga4GgCheckoutReviewPageEventModule {
  constructor(_ga4GgCheckoutReviewPageEventBuilder: Ga4GgCheckoutReviewPageEventBuilder) {}
}
